import { ChangeEvent, FC } from "react";

interface IEditInputFieldProps {
  readonly: boolean;
  data: {
    value: string | number | undefined;
    type: string;
    labelText: string;
    id: number;
  };
  setValue?: Function;
  maxLength?: number;
}

const EditInputField: FC<IEditInputFieldProps> = ({
  readonly,
  data,
  setValue,
  maxLength,
}) => {
  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (setValue) setValue(event.target.value);
  };

  return (
    <div>
      <label
        htmlFor={`edit_input_field_${data.id}`}
        className="block mb-2 text-sm font-medium text-gray-900 "
      >
        {data.labelText}
      </label>
      {readonly ? (
        <input
          type={data.type}
          id={`edit_input_field_${data.id}`}
          className="bg-yellow-200 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 "
          readOnly
          value={data.value}
        />
      ) : (
        <input
          type={data.type}
          id={`edit_input_field_${data.id}`}
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 "
          value={data.value}
          required
          onChange={onChange}
          maxLength={maxLength ? maxLength : 999}
        />
      )}
    </div>
  );
};

export default EditInputField;
